import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {DISPLAYABLE_ITEM_REQUEST_STATUS, ITEM_REQUEST_STATUS_CHIP_COLORS, ItemRequest} from '@store/item-requests/item-requests.types';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ItemRequestsSelectors} from '@store/item-requests/item-requests.selectors';
import {StatusChipComponent} from '@aviary/components/status-chip/status-chip.component';
import {createStringSelector} from '@aviary/store/store.helpers';
import {MxSelectorCreator} from '@aviary/store/store.types';
import {MatBadge} from '@angular/material/badge';
import {Store} from '@ngrx/store';
import {RouterActions} from '@store/aviary/aviary.adapter';
import {MatChipSet} from '@angular/material/chips';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';
import {ActionButtonsComponent} from '@aviary/components/action-buttons/action-buttons.component';
import {HoldIconButtonComponent} from '@app/my-account/holds/hold-actions/hold-icon-button/hold-icon-button.component';

@Component({
  selector: 'px-combined-status-actions-column',
  host: {
    class: 'text-wrap',
  },
  templateUrl: './combined-status-actions-column.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, StatusChipComponent, MatBadge, MatChipSet, IconButtonComponent, ActionButtonsComponent, HoldIconButtonComponent]
})
export class CombinedStatusActionsColumnComponent {
  @Input({required: true}) public itemRequest: ItemRequest;
  @Input() public isClosed: boolean;
  private readonly store = inject(Store);
  public readonly selectors = ItemRequestsSelectors.Stateless;
  public readonly viewportSelectors = ViewportSelectors;
  public readonly chipColors = ITEM_REQUEST_STATUS_CHIP_COLORS;
  public readonly chipNames = DISPLAYABLE_ITEM_REQUEST_STATUS;

  public viewHeldItemsClicked(): void {
    this.store.dispatch(RouterActions.navigateTo('HOLDS'));
  }

  public cancelRequestClicked(): void {
    // TODO: Implement Cancel Request button
  }

  public viewDetailsClicked(): void {
    this.store.dispatch(RouterActions.navigateTo('ITEM_REQUEST_DETAILS', {id: this.itemRequest.id}));
  }

  public readonly badgeFor: MxSelectorCreator<[ItemRequest], string> =
    (itemRequest) => createStringSelector(
      this.selectors.hasUnreadStaffCommentsFor(itemRequest),
      hasComments => hasComments ? '!' : ''
    );

  public readonly viewItemsTooltipFor: MxSelectorCreator<[ItemRequest], string> =
    (itemRequest) => createStringSelector(
      this.selectors.holdPlacedFor(itemRequest),
      holdPlaced => holdPlaced ? 'View Items on Hold' : ''
    );

}
